<template>
  <v-breadcrumbs
    v-if="items.length"
    :items="items"
    divider="›"
    class="app-breadcrumb-header pa-0"
  />
</template>

<script>
export default {
  name: 'AppBreadcrumb',
  props: {
    menu: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    items() {
      return this.findCurrentTrail(this.menu).map((item) => ({
        text: item.titulo,
        disabled: true,
      }));
    },
  },
  methods: {
    normalizePath(path) {
      if (!path || typeof path !== 'string') return '';

      const normalized = path.split(/[?#]/)[0].replace(/\/+$/, '');
      if (!normalized) return '';

      return normalized.startsWith('/') ? normalized : `/${normalized}`;
    },
    belongsToCurrentFrontend(item) {
      return item && item.base_url === window.location.origin;
    },
    matchesCurrentRoute(menuPath, currentPath) {
      if (!menuPath || menuPath === '/') return false;

      return currentPath === menuPath || currentPath.startsWith(`${menuPath}/`);
    },
    findCurrentTrail(nodes, parents = []) {
      const currentPath = this.normalizePath(this.$route.path);
      if (!currentPath || currentPath === '/' || currentPath === '/login') {
        return [];
      }

      let bestMatch = [];
      let bestPathLength = -1;

      const visit = (items, ancestors) => {
        (items || []).forEach((item) => {
          const trail = [...ancestors, item];
          const menuPath = this.normalizePath(item.ruta);

          if (
            this.belongsToCurrentFrontend(item) &&
            this.matchesCurrentRoute(menuPath, currentPath) &&
            menuPath.length > bestPathLength
          ) {
            bestMatch = trail;
            bestPathLength = menuPath.length;
          }

          if (Array.isArray(item.dependencias) && item.dependencias.length) {
            visit(item.dependencias, trail);
          }
        });
      };

      visit(nodes, parents);
      return bestMatch;
    },
  },
};
</script>

<style scoped>
.app-breadcrumb-header {
  flex: 0 1 420px;
  flex-wrap: nowrap;
  max-width: 420px;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

.app-breadcrumb-header >>> li,
.app-breadcrumb-header >>> .v-breadcrumbs__item {
  font-size: 12px;
}

.app-breadcrumb-header >>> .v-breadcrumbs__item {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

@media (max-width: 599px) {
  .app-breadcrumb-header {
    display: none;
  }
}
</style>
